module.exports = __webpack_public_path__ + "img/empty.0a1e7ca8.png";